import React, { useContext } from 'react';
import Markdown from '../../Markdown';
import { FormContext } from '../FormContext';
import InputBase, { MockInput } from '../InputBase';

const TextFieldView = props => {
  const {
    validateField,
    onFormBuilderDefaultValueSaved = () => {},
    onFormBuilderTooltipValueSaved = () => {}
  } = useContext(FormContext);

  return (
    <>
      {props.mockInput ? (
        <MockInput multiline={props.uiType === 'long_text'}>
          <Markdown
            content={props.value}
            allowedTypes={[
              'root',
              'text',
              'strong',
              'emphasis',
              'link',
              'image',
              'paragraph',
              'break',
              'list',
              'listItem'
            ]}
          />
        </MockInput>
      ) : (
        <InputBase
          id={props.internalId}
          variant="outlined"
          value={props.value || ''}
          onChange={props.onValueChange}
          onBlur={() => {
            if (!props.internalId) {
              return;
            }
            if (props.internalId.indexOf('tooltip-') === 0) {
              onFormBuilderTooltipValueSaved(props.internalId, props.value);
            } else {
              validateField(props.internalId);
              onFormBuilderDefaultValueSaved(props.value);
            }
          }}
          inputProps={{
            readOnly: props.readOnly,
            'data-lpignore': 'true',
            maxLength: props.maxLength
          }}
          {...props.muiInputProps}
        />
      )}
    </>
  );
};

export default TextFieldView;
